<template>
  <LayoutMain v-if="asyncDataStatus_isReady">
    <template #aside>
      <div
        class="calculations_list__block"
        v-if="sortedUsersCalculationsList && sortedUsersCalculationsList.length"
      >
      <div class="columns">
        <div class="column">
          <p class="calculations_list__title">{{ $t("Simulações") }}</p>
        </div>
        <div class="column">
          <input class="input" type="text" v-model="search" placeholder="Procurar ..."/>
        </div>
      </div>
        

        

        <div class="calculations_list__list">
          <router-link
            v-for="item in pageOfItems"
            :to="{ name: 'Solution', params: { id: item.id } }"
            :key="item.id"
            class="calculations_list__item"
          >
            <div class="calculations_list__item_header">
              <div class="calculations_list__item_type">
                {{ $t("input.type", item.type) }},
                {{ $t("{totalSpans} vãos", null, { totalSpans: item.spans }) }}
              </div>
              <div class="calculations_list__item_date">
                {{ formatDate(item.date) }}
              </div>
            </div>

            <div class="calculations_list__item_desc">
              “{{ item.name }}”, {{ $t("input.location", item.country) }}
            </div>
          </router-link>
        </div>

        

        <b-select
          class="calculations_list__select"
          v-model="selectedCalculation"
          expanded
          size="is-large"
        >
          <option
            v-for="item in sortedUsersCalculationsList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}, {{ $t("input.location", item.country) }} —
            {{ $t("input.type", item.type) }},
            {{ $t("{totalSpans} vãos", null, { totalSpans: item.spans }) }}
          </option>
        </b-select>
      </div>
      <jw-pagination class="pagination_list" :items="filteredList" @changePage="onChangePage" :labels="customLabels" :styles="customStyles" :pageSize=8 :maxPages=4 :disableDefaultStyles="true"></jw-pagination>
    </template>

    <template #body>
      <template v-if="!sortedUsersCalculationsList.length">
        <p>{{ $t("Não tem cálculos gravados") }}</p>
        <b-button
          tag="router-link"
          :to="{ name: 'Calculator' }"
          type="is-primary"
          size="is-medium"
          >{{ $t("Crie a sua primeira simulação") }}</b-button
        >
      </template>

      <template v-else>
        <transition name="calculationViewAnim" mode="out-in">
          <router-view :key="$route.params.id || ''"></router-view>
        </transition>
      </template>
    </template>
  </LayoutMain>
</template>

<script>
import { asyncDataStatus } from "@/mixins";
import store from "@/store";
import { mapActions, mapGetters } from "vuex";
import LayoutMain from "@/layouts/l-main";
import { SolutionSheet } from "@/components";
import { formatDate } from "@/utils";

function redirectLogic(to, from, next) {
  const { sortedUsersCalculationsList } = store.getters;
  if (
    to.name === "Solutions" &&
    sortedUsersCalculationsList &&
    sortedUsersCalculationsList.length
  ) {
    const firstItem = sortedUsersCalculationsList[0];
    next({ name: "Solution", params: { id: firstItem.id } });
  } else {
    next();
  }
}

const customStyles = {
    
    ".active":{
      color: 'red',
      "background-color": "green"
    }
};

const customLabels = {
    first: '<<',
    last: '>>',
    previous: '<',
    next: '>'
};

export default {
  mixins: [asyncDataStatus],

  components: {
    LayoutMain,
    SolutionSheet,
  },

  props: {
    id: {
      required: false,
    },
  },

  data() {
    return {pageOfItems: [],customStyles,customLabels,search: ''};
  },

  computed: {
    ...mapGetters(["sortedUsersCalculationsList"]),
    filteredList() {
      return this.$store.state.usersCalculationsList.filter(calculation => {
        return calculation.name.toLowerCase().includes(this.search.toLowerCase())
      }).sort((a, b) => {
                return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
            });
    },

    selectedCalculation: {
      get() {
        return this.id;
      },

      set(id) {
        this.$router.push({ name: "Solution", params: { id } });
      },
    },
  },

  methods: {
    ...mapActions(["fetchUsersCalculationsList"]),
    formatDate,
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    }
  },

  created() {
    this.asyncDataStatus_done();
  },

  beforeRouteEnter(to, from, next) {
    store.dispatch("fetchUsersCalculationsList").then(() => {
      redirectLogic(to, from, next);
    });
  },

  beforeRouteUpdate(to, from, next) {
    redirectLogic(to, from, next);
  },
};
</script>

<style lang="scss" scoped>
.calculations_list__title {
  font-family: Titillium Web;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: #ffffff;
  margin-bottom: 0.52em;
}

.calculations_list__list {
  margin: 0 -16px;
}

.calculations_list__item {
  padding: 12px 16px 18px;
  cursor: pointer;
  display: block;
}

.calculations_list__item.is-active--exact,
.calculations_list__item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.calculations_list__item_header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}

.calculations_list__item_type {
  font-family: Titillium Web;
  font-weight: bold;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #999999;
}

.calculations_list__item_date {
  font-family: $font-family-primary;
  font-size: 12px;
  line-height: 14px;
  color: #666666;
}

.calculations_list__item_desc {
  font-family: $font-family-primary;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}

.calculations_list__select {
  display: none;
}

@media screen and (max-width: 1408px) {
  .calculations_list__list {
    display: none;
  }

  .calculations_list__select {
    display: block;
  }

  .pagination_list {
    display:none;
  }
}

$calculationViewAnimDuration: 0.25s;
$calculationAnimTranslateY: -30px;

.calculationViewAnim {
  &-enter-active {
    animation: calculationViewAnimEnter $calculationViewAnimDuration;
  }

  &-leave-active {
    animation: calculationViewAnimLeave $calculationViewAnimDuration;
  }
}

@keyframes calculationViewAnimEnter {
  0% {
    opacity: 0;
    transform: translateY($calculationAnimTranslateY);
  }

  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}

@keyframes calculationViewAnimLeave {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }

  100% {
    opacity: 0;
    transform: translateY($calculationAnimTranslateY);
  }
}

</style>
